import styled from "styled-components";
import MainLayout from "layouts/MainLayout";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { useEffect } from "react";
import InfoBox from "components/InfoBox";
import ProfilePicture from "components/ProfilePic";
import { flags } from "utils/flags";
import { getUser } from "store/slices/userSlice";

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
const Col = styled.div`
  width: calc(50% - 10px);
`;
const Row = styled.div`
  display: flex;
  align-items: center;
`;

const NameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const Text = styled.p`
  color: black;
  font-size: 1.2rem;
`;
const TextBold = styled(Text)`
  font-weight: 500;
  margin-bottom: 8px;
`;

const Icon = styled.img`
  margin-right: 16px;
`;

const InfoItem = styled(Text)``;

const Profile = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("profile");
  const userInfo = useAppSelector((state) => state.user.info);
  const userId: any = useAppSelector((state) => state.user.auth.userId);

  useEffect(() => {
    dispatch(getUser(userId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MainLayout heading={t("nav:myAccount")}>
      <Wrapper>
        <Col>
          <InfoBox title={t("profile")}>
            <InfoWrapper>
              <Row>
                <ProfilePicture />
                <NameWrapper>
                  <TextBold>{userInfo?.name}</TextBold>
                  <Text>@{userInfo?.username}</Text>
                </NameWrapper>
              </Row>
            </InfoWrapper>
          </InfoBox>
          <InfoBox title={t("credentials")}>
            <InfoWrapper>
              <Row>
                <Text>{userInfo?.email}</Text>
              </Row>
            </InfoWrapper>
          </InfoBox>
          <InfoBox title={t("languages")} editable>
            <InfoWrapper>
              <Row>
                {userInfo?.languages?.map((language) => (
                  <Icon key={language} src={flags[language]} />
                ))}
              </Row>
            </InfoWrapper>
          </InfoBox>
        </Col>
        <Col>
          <InfoBox title={t("interests")} editable>
            <InfoWrapper>
              {userInfo?.interests?.map((skill) => (
                <InfoItem key={skill}>{t(`interests:${skill}`)}</InfoItem>
              ))}
            </InfoWrapper>
          </InfoBox>
          <InfoBox title={t("skills")} editable>
            <InfoWrapper>
              {userInfo?.skills?.map((skill) => (
                <InfoItem key={skill}>{skill}</InfoItem>
              ))}
            </InfoWrapper>
          </InfoBox>
        </Col>
      </Wrapper>
    </MainLayout>
  );
};

export default Profile;
